import { render, staticRenderFns } from "./service-config.vue?vue&type=template&id=3d426a22&scoped=true"
import script from "./service-config.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-config.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./service-config.vue?vue&type=style&index=0&id=3d426a22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d426a22",
  null
  
)

export default component.exports